import {SafeUrl} from "@angular/platform-browser";

export class Picture {

  status: PictureStatus = PictureStatus.INVALID;
  data?: Uint8Array<ArrayBuffer>;
  url?: SafeUrl;

  constructor(public key: string, public type: PictureType) {}

  toFile(fileName = 'image.jpg', mimeType = 'image/jpeg'): File | null {
    if (!this.data) return null;
    return new File([this.data], fileName, { type: mimeType });
  }

}

export enum PictureType {
  TYRE,
  VIN,
  LICENSE_PICTURE,
  REGISTRATION_CARD
}

export enum PictureStatus {
  VALID,
  INVALID,
  ERROR,
  UPLOADING
}
